import React from 'react';
import { observer } from 'mobx-react';
import { ExerciseTypeStore } from '@seedlang/stores';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class ExerciseTypeCreate extends React.Component {

  onCreate = name => {
    ExerciseTypeStore.create({data: {name}}, this.props.afterCreate);
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Enter Exercise Type Name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default ExerciseTypeCreate;
